// 配置文件
// API 配置
// 开发环境：使用本地 Node.js 服务器 (http://localhost:8787)
// 生产环境：使用生产环境 API 服务器
// 可以通过环境变量 REACT_APP_WORKER_API 覆盖默认值
export const WORKER_API = process.env.REACT_APP_WORKER_API || (
  process.env.NODE_ENV === 'production' 
    ? 'https://defisea.weekme.workers.dev' // 生产环境仍可使用 Workers 或部署 Node.js 服务器
    : 'http://localhost:8787' // 本地 Node.js 服务器
);

// Google Analytics 配置
// 可以通过环境变量 REACT_APP_GA_MEASUREMENT_ID 覆盖默认值
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

